export enum FirmwareStatus {
	IncompatibleTooOld = 'INCOMPATIBLE_TOO_OLD',
	IncompatibleTooNew = 'INCOMPATIBLE_TOO_NEW',
	CompatibleOld = 'COMPATIBLE_OLD',
	CompatibleNew = 'COMPATIBLE_NEW',
	CompatibleLatest = 'COMPATIBLE_LATEST'
}
